import { collection, doc, getFirestore } from "firebase/firestore";

export const generateFirestoreId = () => {
  return doc(collection(getFirestore(), "ids")).id;
};
